import { render, staticRenderFns } from "./ParkingBarriersArchive.vue?vue&type=template&id=6a932b00&scoped=true&"
import script from "./ParkingBarriersArchive.vue?vue&type=script&lang=js&"
export * from "./ParkingBarriersArchive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a932b00",
  null
  
)

export default component.exports